import React from "react";
import { css } from "emotion";
import { NavLink, useLocation } from "react-router-dom";

import { colors, textSizes, boxStyles } from "../styles/theme";
import logo from "../assets/logo-dark.svg";
import mobileLogo from "../assets/logo-dark.svg";

const SwitchHeader = () => {
  const currentRoute = useLocation();
  const isWorkspace = currentRoute.pathname.includes("workspace");
  return (
    <div className={container}>
      <div className="routeHeader">
        <div className="logo">
          <img className="desktop-logo" src={logo} />
          <img className="mobile-logo" src={mobileLogo} />
        </div>
        {!isWorkspace && (
          <div className="switch">
            <NavLink to="/signup" activeClassName="active">
              Sign Up
            </NavLink>
            <NavLink to="/login" activeClassName="active">
              Log In
            </NavLink>
          </div>
        )}
      </div>
    </div>
  );
};

export default SwitchHeader;

const container = css`
  display: flex;
  flex-direction: column;
  flex: 1;

  .routeHeader {
    background-color: white;
    display: flex;
    flex-direction: row;
  }

  .logo {
    display: flex;
    flex: 1;
    align-items: left;
    padding: 15px 0 5px 30px;

    .desktop-logo {
      display: none;
    }

    img {
      max-height: 30px;
    }

    @media screen and (min-width: ${boxStyles.desktopBreak}) {
      &:after {
        padding: 7px 0 5px 15px;
      }

      .desktop-logo {
        display: flex;
      }

      .mobile-logo {
        display: none;
      }
    }
  }

  .switch {
    flex: 1;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10px 15px 0 0;
    max-width: 160px;
  }
  a,
  a:visited,
  a:hover,
  a:active {
    text-decoration: none;
    color: inherit;
    position: relative;

    &.active:after {
      content: "";
      width: 100%;
      background-color: ${colors.brandColor};
      position: absolute;
      height: 2px;
      left: 0;
      bottom: -8px;
    }
  }
`;
